import { attr, belongsTo, hasMany } from '@ember-data/model';
import ShModel from './sh-model';

const Blast = ShModel.extend({
  // attributes
  blastCount: attr('number'),
  createdAt: attr('date'),
  locationRadius: attr('number'),
  minRating: attr('number'),
  didExpandServices: attr('boolean'),

  // relationships
  assignment: belongsTo('assignment', { async: false }),
  locations: hasMany('location', { async: false }),
  services: hasMany('service', { async: false }),
  users: hasMany('user', { async: false }),
  blastUsers: hasMany('blastUser', { async: false }),
});

export default Blast;
